﻿import React from 'react';
import PropTypes from 'prop-types';
import { useForm, Controller } from 'react-hook-form';

import { TextInput, PhoneNumberInput, Autocomplete } from 'components/Form';
import Button from 'components/Button';
import { getTimeZones } from 'helpers/getTimeZones';

import theme from "./GeneralInformationForm.module.sass";

const GeneralInformationForm = ({ onSubmit }) => {
  const { register, control, handleSubmit, formState: { errors } } = useForm();

  return (
    <form
      className={theme.GeneralInformationForm}
      onSubmit={handleSubmit(onSubmit)}
    >
      <h2 className={theme.SectionTitle}>Tell us more about you</h2>
      <div className={theme.HorizontalGroup}>
        <div className={theme.InputGroup}>
          <label htmlFor="occupation" className={theme.Label}>
            Occupation*
          </label>
          <TextInput
            id="occupation"
            {...register("occupation", { required: 'Enter your occupation' })}
            error={errors.occupation?.message}
          />
        </div>
        <div className={theme.InputGroup}>
          <label htmlFor="timeZone" className={theme.Label}>
            Time Zone*
          </label>
          <Controller
            control={control}
            name="timeZone"
            id="timeZone"
            render={({ field: { onChange, value } }) => (
              <Autocomplete
                name="timeZone"
                id="timeZone"
                value={value}
                onChange={(_, data) => onChange(data)}
                getOptionLabel={(tz) => tz?.name}
                // MUI v7 calls renderOption(props, option, state); v4 called it with
                // (option, state). The v4 form shipped and read fields off the <li> props,
                // so every option rendered "(GMT undefined) undefined" and, because a bare
                // string came back instead of an <li>, nothing was selectable. `key` is
                // pulled out because React refuses it inside a spread. No optional
                // chaining on purpose: a wrong shape should fail loudly, not render text.
                renderOption={(props, tz) => {
                  const { key, ...optionProps } = props;
                  return (
                    <li key={key} {...optionProps}>
                      {`(GMT ${tz.utcOffsetStr}) ${tz.name}`}
                    </li>
                  );
                }}
                options={getTimeZones()}
                error={errors.timeZone?.message}
              />
            )}
            rules={{ required: 'Please select your Time zone' }}
          />
        </div>
      </div>
      <h2 className={theme.SectionTitle}>How can we contact you?</h2>
      <div className={theme.HorizontalGroup}>
        <div className={theme.InputGroup}>
          <label htmlFor="phone" className={theme.Label}>
            Phone*
          </label>
          <Controller
            render={({ field }) => <PhoneNumberInput {...field} id="phone" placeholder="Enter your phone number" error={errors.phone?.message} />}
            name="phone"
            control={control}
            rules={{ required: 'Enter your phone number' }}
            defaultValue=""
          />
        </div>
        <div className={theme.InputGroup}>
          <label htmlFor="altPhone" className={theme.Label}>
            Alt Phone
          </label>
          <Controller
            render={({ field }) => <PhoneNumberInput {...field} id="altPhone" placeholder="Enter your phone number" />}
            name="altPhone"
            control={control}
            defaultValue=""
          />
        </div>
      </div>
      <footer className={theme.FormFooter}>
        <Button size="big" type="submit">
          Continue
        </Button>
      </footer>
    </form>
  );
};

GeneralInformationForm.propTypes = {
  onSubmit: PropTypes.func.isRequired,
};

export default GeneralInformationForm;
